<template>
  <div v-if="examenes400" class="">

    <b-alert
      v-for="(item, index) in examenes400"
      :key="index" show
      :variant="getVariantCard(item.accion)"
      class="my-2 p-2 card-labs"
    >
      <div class="d-flex justify-content-end align-items-center">
        <small class="text-muted">{{ item.accion.toUpperCase() }}</small>
        <b-button 
          v-if="canEditItem(item)"
          variant="warning" 
          size="sm" 
          class="card-button"
          @click="onEditProceso(index)"
        >
          <i class="fa-solid fa-pen"/>
        </b-button>

        <b-button 
          v-if="canDeleteItem(item)"
          variant="danger" size="sm" 
          class="card-button"
          @click="onRemoveLab(index)"
        >
          <i class="fa-solid fa-x"/>
        </b-button>

        <b-button 
          v-if="item.accion === 'eliminar'"
          variant="warning" 
          size="sm"
          class="card-button"
          @click="onRestoreItem(index)"
          title="Restaurar Item"
        >
          <i class="fa-solid fa-rotate-right"/>
        </b-button>
      </div>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Estado: </strong> 
        <span class="text-dark">{{ getEstadoLabText(item.estadoLaboratorio) || '-' }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">N. Orden: </strong> 
        <span class="text-dark">{{ item.codigoOrden || '-' }}</span>
      </b-row>

      <b-row style="margin-bottom: 5px;">
        <strong class="item-label">Laboratorios: </strong> 
  
        <div class="">
          <div 
            v-for="(lab, index) in item.laboratorios" 
            :key="index"
            class="text-dark"
          >
            {{ lab.text }}
          </div>
        </div>
        
      </b-row>

    </b-alert>
  </div>
</template>

<script>
export default {
  
  props: {
    examenes400: {
      type: Array,
      default: () => []
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },



  methods:{


    canEditItem(item){
      const estadoValido = item.estadoLaboratorio !== 'Incompleto' && item.estadoLaboratorio !== 'Terminada';
      return item.accion !== 'eliminar' && estadoValido && !this.onlyView
    },


    onEditProceso(index) {
      this.navigateToQuery("editLab", index);
    },


    canDeleteItem(item){
      const estadoValido = item.estadoLaboratorio !== 'Incompleto' && item.estadoLaboratorio !== 'Terminada';
      return item.accion !== 'eliminar' && estadoValido && !this.onlyView
    },

    onRestoreItem(index){
      this.examenes400[index].accion = 'registrado'
    },

    async onRemoveLab(index) {

      const result = await this.$swal({
        title: 'Eliminar examen',
        text: '¿Está seguro de eliminar el examen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Eliminar',
        cancelButtonText: 'No, Cancelar',
        confirmButtonColor: '#d33',
      });

      if (!result.isConfirmed) return;
      
      if(this.examenes400[index].accion !== 'crear'){
        this.examenes400[index].accion = 'eliminar';
        return;
      }

      this.examenes400.splice(index, 1);
    },



    getVariantCard(action){

      const variant = action === 'registrado' 
        ? 'success'
        : action === 'editar'
          ? 'warning'
          : action === 'eliminar'
            ? 'danger'
            : 'info';

      return variant;
    },

    getEstadoLabText(estado){
      if(estado === '1') return 'Creado';
      if(estado === '2') return 'Programado';
      if(estado === '3') return 'Vinculado';
      if(estado === '4') return 'Validado';
      return '-';
    },

    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },


  },


  watch: {
    examenes400(newValue) {
      console.log("this.examenes400", newValue)
    }
  },
}
</script>

<style>
  .card-labs .item-label {
  width: 150px;
  margin-left: 10px;
}

.card-labs .card-button {
  margin-left: 8px;
  padding: 5px;
}
</style>